module.exports = __webpack_public_path__ + "static/media/kitchen-more2.cb849887.jpg";